import styles from "./SectionServicesInfo.module.css";
import aboutImageInfo from "../../assets/images/servicios/Frame 87.png";
import { Link } from "react-router-dom";
const SectionServicesInfo = () => {
  return (
    <section>
      <div className={styles.container}>
        <img
          src={aboutImageInfo}
          className={styles.image}
          alt="Servicios"
          loading="lazy"
        />
        <div className={styles.overlay}>
          ¿Te interesa alguno de nuestros servicios?
          <Link
            onClick={() => window.scrollTo(0, 0)}
            to="/contacto"
            className={styles.button}
          >
            Informes
          </Link>
        </div>
      </div>
    </section>
  );
};

export default SectionServicesInfo;
